import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getMotorVehicleSlice = createSlice({
  name: "getMotorVehicle",
  initialState,
  reducers: {
    getMotorVehicleStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getMotorVehicleSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getMotorVehicleFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getMotorVehicleStart,
  getMotorVehicleSuccess,
  getMotorVehicleFailure,
  clearError,
  clearMessage,
} = getMotorVehicleSlice.actions;

export default getMotorVehicleSlice.reducer;
